import { ArrowInCircleRightIcon } from '@vlabs/icons';
import { IconButton } from '@vlabs/uikit/components/controls/button/icon-button';
import type { IconButtonProps } from '@vlabs/uikit/components/controls/button/icon-button';
import { routes } from '@vlapps/point/src/app/routes';
import { generatePath, Link } from 'react-router-dom';

import { buildTestid } from '@vlabs/monokit/shared/lib/utils';

import type { GoToRole } from './types';

type GoToRoleIconButtonProps = GoToRole & IconButtonProps;

const displayName = 'GoToRoleIconButton';
const testid = buildTestid(displayName);

function GoToRoleIconButton({
  roleId,
  'data-testid': dataTestId = undefined,
  ...props
}: GoToRoleIconButtonProps): JSX.Element {
  return (
    <IconButton
      as={Link}
      icon={<ArrowInCircleRightIcon />}
      kind="secondary"
      to={() => generatePath(routes.roles.view, { roleId })}
      variant="flat"
      {...testid(dataTestId)}
      {...props}
    />
  );
}

GoToRoleIconButton.displayName = displayName;

export { GoToRoleIconButton };
